<template>
  <div>
    <AssessmentDashboard />
  </div>
</template>

<script>
import AssessmentDashboard from "../components/AssessmentDashboard";
import DefaultLayout from "@/layouts/DefaultLayout";

export default {
  name: "Company",
  created() {
    this.$emit(`update:layout`, DefaultLayout);
  },
  components: {
    AssessmentDashboard,
  },
};
</script>